module.exports = __webpack_public_path__ + "img/renew.2618c921.png";